function LessonItem({el}) {
    return (
        <>
            <li>{el}</li>
        </>
    )
}
export default LessonItem